<template lang="html">
  <v-container class='fluid'>
    <v-layout align-center justify-center>
      <v-flex xs10>
        <v-card class="text-xs-center">
          <basic-toolbar :title="'Criar novo tipo de bolsa'"></basic-toolbar>
          <v-card-text>
            <v-form v-model="formularioValido" ref="form">
            <v-container>
              <v-layout row wrap justify-space-between>
                <v-flex xs11 sm3>
                  <v-text-field
                    label='Código'
                    v-model="bolsa.codigo"
                    required
                    :rules="regrasBasicas"
                    max-height="20">
                  </v-text-field>
                </v-flex>

                <v-flex xs11 sm8>
                  <v-select
                    label='Unidade'
                    :items="listaPermissoesUnidades"
                    v-model="bolsa.unidade.id"
                    item-text="nome"
                    item-value="id"
                    max-height="400"
                    required
                    autocomplete
                    :rules="regrasBasicas"
                  ></v-select>
                </v-flex>
              </v-layout>

              <v-layout row wrap justify-space-between>
                <v-flex xs12>
                  <v-text-field
                    label='Descrição'
                    v-model="bolsa.descricao"
                    required
                    :rules="regrasBasicas"
                    max-height="400">
                  </v-text-field>
                </v-flex>
              </v-layout>

              <v-layout row wrap justify-space-between>
                <v-flex xs11 sm4>
                  <v-text-field
                    label='Valor (R$)'
                    v-model="bolsa.valor"
                    required
                    :rules="regrasBasicas"
                    max-height="20">
                  </v-text-field>
                </v-flex>
                <v-flex xs11 sm4>
                  <v-text-field
                    label='Número de bolsas disponibilizadas'
                    v-model="bolsa.vagasOferecidas"
                    required
                    :rules="regrasBasicas"
                    max-height="20">
                  </v-text-field>
                </v-flex>
              </v-layout>

              <v-layout row wrap>
                <v-flex xs11 sm5>
                  <c-date-menu
                    label="Data inicial de vigência da bolsa"
                    v-model="bolsa.dtInicio"
                    clearable
                    required
                    :rules="regrasBasicas"
                  ></c-date-menu>
                </v-flex>
                <v-spacer></v-spacer>
                <v-flex xs11 sm5>
                  <c-date-menu
                    label="Data final de vigência da bolsa"
                    v-model="bolsa.dtFim"
                    clearable
                    required
                    :rules="regrasBasicas"
                  ></c-date-menu>
                </v-flex>
              </v-layout>

              <br>

              <v-file-input
                label="Anexar arquivo comprobatório da concessão das bolsas (pdf)"
                v-model="arquivo"
                accept=".pdf"
                show-size
                outlined
                required
                :rules="regrasBasicas"
              ></v-file-input>


              </v-container>
            </v-form>
            <v-divider></v-divider>
            <v-card-actions>
              <v-btn color="primary" text @click="$router.go(-1)">Cancelar</v-btn>
              <v-spacer></v-spacer>
              <v-btn color="primary" text @click="criarBolsa" :disabled="!formularioValido">Criar</v-btn>
            </v-card-actions>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import BasicToolbar from '@/components/toolbars/basic-toolbar'
  import ToolTip from '@/components/app-layouts/app-tooltip/tooltip'
  import DateMenu from '@/components/c-date-menu'
  import bolsas from '@/utils/bolsas'
  import { mapActions } from 'vuex'

  export default {
    data: () => ({
      formularioValido: false,
      listaPermissoesUnidades: [],
      arquivo: undefined,
      bolsa: {
        codigo: '',
        descricao: '',
        valor: undefined,
        vagasOferecidas: undefined,
        unidade: {}
      },
      regrasBasicas: [
        (input) => !!input || 'Este campo é obrigatório'
      ],
      assuntoSummaryRules: [
        (input) => !!input || 'Este campo é obrigatório',
        (input) => !!input && input.length <= 200 || 'Este campo não pode possuir mais que 200 caracteres'
      ]
    }),
    methods: {
      ...mapActions('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']),
      criarBolsa: function () {
        this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Criando Bolsa.' })
        bolsas.postBolsa(this.bolsa.unidade.id, this.bolsa)
        .then(response => {
          this.SHOW_SNACKBAR({snackbarType: 'success', snackbarText: response.body.mensagem})
          this.$router.push({name: 'ListaBolsas'})
        })
        .catch(error => {
          this.SHOW_SNACKBAR({snackbarType: 'error', snackbarText: error.body.mensagem})
        })
        .finally(() => {
          this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Criando Bolsa.' })
        })
      }
    },
    mounted () {
      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando unidades.' })
      bolsas.getPermissoesUnidades()
      .then(response => {
        this.listaPermissoesUnidades = response.data.slice()
      })
      .catch(error => {
        this.SHOW_SNACKBAR({snackbarType: 'error', snackbarText: error.body.mensagem})
      })
      .finally(() => {
        this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando unidades.' })
      })
    },
    components: {
      'basic-toolbar': BasicToolbar,
      'tooltip': ToolTip,
      'c-date-menu': DateMenu
    }
  }
</script>

<style lang="css">
  .menu {
    display: block !important;
  }

  .no-resize div textarea{
    resize: none;
  }
  .input-group__icon-cb {
    cursor: pointer !important;
  }
</style>



// WEBPACK FOOTER //
// criar-bolsa.vue?ce04023a